import { render } from "./registration.vue?vue&type=template&id=17fac0e4"
import script from "./registration.vue?vue&type=script&lang=js"
export * from "./registration.vue?vue&type=script&lang=js"

import "./registration.vue?vue&type=style&index=0&id=17fac0e4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__